import styled from '@emotion/styled';
import AddIcon from '@mui/icons-material/Add';
import { Box, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Item, WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';
const StyledListItem = styled(ListItem)({
  backgroundColor: WsColors.White,
  borderRadius: 3,
  border: '1px solid' + WsColors.TheBlues200,
  cursor: 'pointer',
  padding: 12,
});
const StyleItem = styled(Item)(({ theme }) => ({
  padding: theme.spacing(1),
}));
export interface ComponentProps {
  onClickPlaceholder(placeholder: string): void;
}
const RtrPlaceholder = ({ onClickPlaceholder }: ComponentProps) => {
  const rtrPlaceholdersData = [
    { key: 'Page Break', value: '{{PAGE_BREAK}}' },
    { key: 'Candidate Signature', value: '{{SIGNATURE}}' },
  ];
  const handleListItemClick = (placeholder: string) => onClickPlaceholder(placeholder);
  return (
    <Box>
      {rtrPlaceholdersData.map(({ key, value }) => (
        <StyleItem key={key}>
          <StyledListItem onClick={() => handleListItemClick(value)}>
            <ListItemText primary={key} />
            <ListItemIcon>
              <AddIcon />
              <WsTypography color={WsTypoColors.PRIMARY} variant={WsTypoVariants.BODY1}>
                Add
              </WsTypography>
            </ListItemIcon>
          </StyledListItem>
        </StyleItem>
      ))}
    </Box>
  );
};
export default RtrPlaceholder;
